module.exports = __webpack_public_path__ + "static/media/sqsSa_sm4.8e2ec87c.jpeg";